export const normalizeAccentsNDiacriticsChars = (str: string) => {
    // Normalize will decompose è to ` e
    // Then we remove the ` and keep the e
    return str.normalize('NFD').replace(/\p{Diacritic}/gu, '');
};
